<app-youtube-player *ngIf="(liveStream != undefined) && (liveStream.source === 'youtube')" [id]=liveStream?.youtubeId [showProgress]="false"></app-youtube-player>

